import { render, staticRenderFns } from "./WalletTransaction.vue?vue&type=template&id=91e2f5a8&scoped=true"
import script from "./WalletTransaction.vue?vue&type=script&lang=js"
export * from "./WalletTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e2f5a8",
  null
  
)

export default component.exports